import { render, staticRenderFns } from "./ProductTemplate.vue?vue&type=template&id=142b5e05&scoped=true&"
import script from "./ProductTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductTemplate.vue?vue&type=style&index=0&id=142b5e05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b5e05",
  null
  
)

export default component.exports